import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from "antd";
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/index';

const AlumniPrivacyOptionsModal = (props) => {

    const parsedExtendedProfile = JSON.parse(localStorage.getItem('extendedProfile'));


    const [ShowPopup, setShowPopup] = useState({})
    const handleClick = async () => {
        const extendedProfile = { ...parsedExtendedProfile, needToShowAlumniPrivacyOptionsPopup: false }
        const success = await props.actions.UpdatePrivacySettingsDate(extendedProfile.extendedProfileId ? extendedProfile.extendedProfileId : null)
        if (success) {
            setShowPopup(false);
            localStorage.setItem('extendedProfile', JSON.stringify(extendedProfile));
        }
    };

    useEffect(() => {

        setShowPopup(parsedExtendedProfile.needToShowAlumniPrivacyOptionsPopup)
    }, [])

    return (
        <Modal
            // centered
            className='ExistingLifeTimePlanModal modalWidth'
            // style={{width: '700px !important'}}
            visible={ShowPopup}
            title={<div style={{ display: 'flex', alignItems: 'center' }} >
                <Icon type="info-circle" theme="twoTone" style={{ fontSize: '25px', marginRight: '10px' }} /> Privacy Settings Options!
            </div>
            }
            closable={false}
            footer={
                <Button key="submit" type="primary" className='RedirectExistingLifePlan' loading={props.isUpdating} disabled={props.isUpdating}
                    onClick={handleClick}>
                    I Agree
                </Button>
            }
        >
            <div >
                {/* <div>
                    <Icon type="info-circle" theme="twoTone" style={{fontSize: '40px'}} />
                </div> */}

                <div className='Existing-Lifeplan-Info' style={{ textAlign: 'start' }}>
                    <span className='modal-desc' style={{ color: '#595959' }}>  The following features have been added to the Spark directory. Please review each item in your personal profile and confirm if your information will remain private or can be viewed by other Spark users.</span>

                    <span className='modal-desc' style={{ color: '#595959' }}>Checking the ‘I agree’ box is your confirmation the information will not be displayed unless requested by selecting the appropriate checkbox.</span>
                </div>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => {
    return {
        isUpdating: state.updatePrivacysettingsreducer.isUpdating
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlumniPrivacyOptionsModal));



// WEBPACK FOOTER //
// ./src/components/Dashboard/privacyOptionsModal.js